import { useCareer, UseCareerResponse } from "@hooks/game/use-career";
import React, { createContext, ReactNode, useContext, useState } from "react";

interface CareerContextType extends UseCareerResponse {
  // Only UI dialog state
  isPositionDialogOpen: boolean;
  openPositionDialog: () => void;
  closePositionDialog: () => void;
  handlePositionsSelected: (positions: any[]) => void;
}

const CareerContext = createContext<CareerContextType | undefined>(undefined);

export const CareerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isPositionDialogOpen, setIsPositionDialogOpen] = useState(false);

  const careerData = useCareer();

  const openPositionDialog = () => setIsPositionDialogOpen(true);
  const closePositionDialog = () => {
    setIsPositionDialogOpen(false);
  };
  const handlePositionsSelected = (positions: any[]) => {
    careerData.setSelectedPositions(positions);
    setIsPositionDialogOpen(false);
  };

  const contextValue = {
    ...careerData,
    isPositionDialogOpen,
    openPositionDialog,
    closePositionDialog,
    handlePositionsSelected,
  };

  return <CareerContext.Provider value={contextValue}>{children}</CareerContext.Provider>;
};

export const useCareerContext = () => {
  const context = useContext(CareerContext);
  if (context === undefined) {
    throw new Error("useCareerContext must be used within a CareerProvider");
  }
  return context;
};
